enum DownloadEnforcementModalText {
  ButtonTitle = "Download the Equip app",
  DismissAccessibilityLabel = "Dismiss download the Equip app",
  QRCaption = "Scan the QR code to download or search Equip Health in the App Store or Google Play Store",
  QRCodeAccessibilityLabel = "App Store download QR code",
  Title = "Your Equip experience is better in the app",
}

const DownloadEnforcementBullets = [
  { id: "biometric", text: "Biometric login for easy access" },
  {
    id: "notifications",
    text: "Push notifications to stay on top of your treatment",
  },
  {
    id: "on-the-go",
    text: "Access your treatment on the go when you need it the most",
  },
] as const;

export { DownloadEnforcementBullets, DownloadEnforcementModalText };
